/**
 * Nombres y etiquetas de los CIs que aparecen en el IPAM.
 *
 * POR QUÉ ESTÁ AQUÍ
 * ---------------------------------------------------------------------------
 * Cada pantalla del IPAM (IPs, Asignaciones, Explorer, Resumen) se montaba su
 * propia tabla de etiquetas y su propio catálogo de nombres, y los dos eran
 * cortos: solo servidor / team / elemento de rack / workstation / impresora /
 * teléfono. Un AP, una VM o un router salían como `#22` y «wifi_ap».
 *
 * El nombre ahora lo manda resuelto el backend (`object_name`, en lote con
 * `resolve_ci_labels`), así que aquí solo queda:
 *   · `ciTypeLabel()`     – etiqueta legible del tipo (catálogo compartido).
 *   · `assignmentName()`  – nombre del CI con respaldo local por si la fila
 *                           apunta a un elemento ya borrado.
 */
import { etiquetaObjeto } from '../config/objectTypes';

/** Tipos que usa el IPAM y que no están en el catálogo general de objetos. */
const EXTRA_LABELS = {
  server_team: 'Team red',
  rack_element: 'Elemento de rack',
  virtual_group: 'Grupo VIP',
};

/** Etiqueta legible de un `object_type` del IPAM. */
export function ciTypeLabel(tipo) {
  if (!tipo) return '';
  return EXTRA_LABELS[tipo] || etiquetaObjeto(tipo) || tipo;
}

/**
 * Nombre visible de una asignación.
 *
 * @param {object} asgn      fila de `ipam_ip_assignments`
 * @param {object|Map} [cat] catálogo local `{ 'wifi_ap:22': 'Nombre' }`
 */
export function assignmentName(asgn, cat) {
  if (!asgn) return '';
  if (asgn.object_name) return asgn.object_name;
  const key = `${asgn.object_type}:${asgn.object_id}`;
  const local = cat instanceof Map ? cat.get(key) : cat?.[key];
  return local || `#${asgn.object_id}`;
}

export default assignmentName;
